import { useState, useEffect } from 'react';
import axios from 'axios';

export default function usePostData(url, dependencies = [], payload = null, options = {}, initialData = null) {
  const [data, setData] = useState(initialData);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!payload) return;

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.post(url, payload, options);
        setData(response.data);
      } catch (err) {
        console.error('POST request failed:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, dependencies); // När dependencies ändras, körs hooken

  return [isLoading, data, error];
}
